import { styled } from '@mui/material';

export const StyledLessonSectionWrap = styled('div')(({ theme }) => ({
	display: 'grid',
	gap: '16px',
	flex: 1,
	gridTemplateColumns: '3fr 1fr',

	[theme.breakpoints.down('lg')]: {
		gridTemplateColumns: '1fr',
	},
}));

export const StyledLessonGridItem = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	background: 'transparent',
	borderRadius: '24px',
	position: 'relative',
	padding: '8px',

	'&::before': {
		content: '""',
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: -1,
		borderRadius: 'inherit',
		padding: '3px',
		background:
			'linear-gradient(110.21deg, rgba(255, 255, 255, 0.7) 2.78%, rgba(255, 250, 203, 0.534754) 58.48%, rgba(255, 57, 57, 0.07) 72.66%, rgba(255, 255, 255, 0.595) 100%)',
		WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
		WebkitMaskComposite: 'xor',
		maskComposite: 'exclude',
	},
});
